import ApiRequester from "./ApiRequester.jsx";
import {logout as amplifyLogout} from "../services/auth";

function Logout(dData) {
    try{
        let payload = [{campus_id: dData.acnt, user_id: dData.user, user_log_type_id: 2, modified_by: dData.user}]
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_user_logs", Payload: payload, urlType: "PUT",
                            CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(() => {
            // Sign out of Cognito (clears Amplify-managed tokens) then clear app session
            amplifyLogout().finally(() => {
                sessionStorage.clear();
                return window.location.href = "/";
            });
        });
    }catch (e) {
        amplifyLogout().finally(() => {
            sessionStorage.clear();
            return window.location.href = "/";
        });
    }
}

export default Logout;
